import type { ReactElement } from 'react';

import {
  ACHIEVEMENT_FALLBACK_TYPES,
  ACHIEVEMENT_TIERS,
  ACHIEVEMENT_TYPES,
} from '@didaskill/domain/user-achievements/constants';

import { STICKER_SIZES, STICKER_TYPES } from '../sticker/constants';
import type { AchievementBackgroundProps } from './Achievement';
import { BronzeBackground } from './achievement-backgrounds/BronzeBackground';
import { GoldBackground } from './achievement-backgrounds/GoldBackground';
import { NeutralBackground } from './achievement-backgrounds/NeutralBackground';
import { QuestBackground } from './achievement-backgrounds/QuestBackground';
import { SilverBackground } from './achievement-backgrounds/SilverBackground';
import { BronzePlaceholder } from './placeholders/BronzePlaceholder';
import { GoldPlaceholder } from './placeholders/GoldPlaceholder';
import { NeutralPlaceholder } from './placeholders/NeutralPlaceholder';
import { QuestPlaceholder } from './placeholders/QuestPlaceholder';
import { SilverPlaceholder } from './placeholders/SilverPlaceholder';

export const TYPE_ICON_MAPPING: Partial<
  Record<ACHIEVEMENT_TYPES | ACHIEVEMENT_FALLBACK_TYPES, STICKER_TYPES>
> = {
  [ACHIEVEMENT_TYPES.CONNECTION_STREAK]: STICKER_TYPES.FIRE,
  [ACHIEVEMENT_TYPES.EASTER_EGGS_2025]: STICKER_TYPES.EGG,
  [ACHIEVEMENT_TYPES.APPOINTMENT_SCHEDULED]: STICKER_TYPES.PHONE,
  [ACHIEVEMENT_TYPES.EXERCISE_COMPLETED]: STICKER_TYPES.BRAIN,
  [ACHIEVEMENT_TYPES.EXERCISE_PERFECT_SCORE]: STICKER_TYPES.CHECK_LIST,
  [ACHIEVEMENT_TYPES.FEEDBACK_CAMPAIGN_ANSWERED]: STICKER_TYPES.THUMB,
  [ACHIEVEMENT_TYPES.HELP_IT_TEAM]: STICKER_TYPES.HANDS_HEART,
  [ACHIEVEMENT_TYPES.PROFILE_PICTURE_ADDED]: STICKER_TYPES.PICTURES,
  [ACHIEVEMENT_TYPES.LESSON_AUDIO_LISTENED]: STICKER_TYPES.K7,
  [ACHIEVEMENT_TYPES.LESSON_COMPLETED]: STICKER_TYPES.BOOK,
  [ACHIEVEMENT_TYPES.VIRTUAL_CLASSROOM_ATTENDED]: STICKER_TYPES.REC,
  [ACHIEVEMENT_TYPES.CLASS_JOINED]: STICKER_TYPES.CLASS_JOINED,

  // Quests
  [ACHIEVEMENT_TYPES.CAMPUS_EXPLORER]: STICKER_TYPES.MOUNTAIN,
  [ACHIEVEMENT_TYPES.GOOD_HABITS]: STICKER_TYPES.HANDSHAKE,
  [ACHIEVEMENT_TYPES.GAIN_CONFIDENCE]: STICKER_TYPES.MEMO,
  [ACHIEVEMENT_TYPES.SNAP_FINGERS]: STICKER_TYPES.SNAP_FINGERS,

  [ACHIEVEMENT_FALLBACK_TYPES.DEFAULT]: STICKER_TYPES.TROPHY,
  [ACHIEVEMENT_FALLBACK_TYPES.DEFAULT_MULTIPLE]: STICKER_TYPES.TROPHIES,
};

export const ACHIEVEMENT_BACKGROUND_SIZE_MAP: Record<STICKER_SIZES, number> = {
  [STICKER_SIZES.SMALL]: 40,
  [STICKER_SIZES.MEDIUM]: 56,
  [STICKER_SIZES.LARGE]: 64,
  [STICKER_SIZES.OVERSIZE]: 72,
  [STICKER_SIZES.GIANT]: 164,
};

export const TIER_BACKGROUND_MAP = (
  size: AchievementBackgroundProps['size'],
): Record<ACHIEVEMENT_TIERS, ReactElement> => ({
  [ACHIEVEMENT_TIERS.NEUTRAL]: <NeutralBackground size={size} />,
  [ACHIEVEMENT_TIERS.BRONZE]: <BronzeBackground size={size} />,
  [ACHIEVEMENT_TIERS.SILVER]: <SilverBackground size={size} />,
  [ACHIEVEMENT_TIERS.GOLD]: <GoldBackground size={size} />,

  [ACHIEVEMENT_TIERS.QUEST]: <QuestBackground size={size} />,
});

export const TIER_PLACEHOLDER_MAP = (
  size: AchievementBackgroundProps['size'],
): Record<ACHIEVEMENT_TIERS, ReactElement> => ({
  [ACHIEVEMENT_TIERS.NEUTRAL]: <NeutralPlaceholder size={size} />,
  [ACHIEVEMENT_TIERS.BRONZE]: <BronzePlaceholder size={size} />,
  [ACHIEVEMENT_TIERS.SILVER]: <SilverPlaceholder size={size} />,
  [ACHIEVEMENT_TIERS.GOLD]: <GoldPlaceholder size={size} />,

  [ACHIEVEMENT_TIERS.QUEST]: <QuestPlaceholder size={size} />,
});
